(function($) {
  $(".single-post-slider").slick({
    slidesToShow:1,
    slidesToScroll:1,
    arrows: true,
    fade: true,
    adaptiveHeight: true,
    asNavFor:".single-post-slider-nav"
  });

  $(".single-post-slider-nav").slick({
    slidesToShow:4,
    slidesToScroll:1,
    asNavFor:".single-post-slider",
    dots: true,
    centerMode: true,
    arrows: false,
    focusOnSelect: true
  });

  $(".block-slider").slick({
    slidesToShow:1,
    slidesToScroll:1,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  });

  $('.post-carousel.post, .post-carousel.external').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.post-carousel.issue').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      },
    ]
  });

  if (document.body.clientWidth < 991) {
    $('.sidebar-right .internal').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
    });

    $('.sidebar-right .internal').slick('slickRemove', false);

  }
  
})(jQuery);